package com.timacookies

import androidx.compose.runtime.Composable

interface AppStrings {
  val navHome: String
  val navCreations: String
  val heroTitle: String
  val heroDetail: String
  val philTitle: String
  val philPara1: String
  val philPara2: String
  val selectionTitle: String
  val viewAllCreations: String
  val creationPersonalizedFavor: String
  val creationModernWeddingDesc: String
  val creationArtisticFloral: String
  val creationArtisticFloralDesc: String
  val creationLaceMonogram: String
  val creationLuxuryGoldDesc: String
  val creationsHeroTitle: String
  val modernWeddingSubtitle: String
  val artisticFloralSubtitle: String
  val luxuryGoldSubtitle: String
  val modernWeddingComposition: List<String>
  val modernWeddingProcess: List<String>
  val artisticFloralComposition: List<String>
  val artisticFloralProcess: List<String>
  val luxuryGoldComposition: List<String>
  val luxuryGoldProcess: List<String>
  val composition: String
  val process: String
  val backToTop: String
  val privacyPolicy: String
  val socialTitle: String
  val contactTitle: String
}

object EnStrings : AppStrings {
  override val navHome = "Home"
  override val navCreations = "Creations"
  override val heroTitle = "Cookies that tell your story"
  override val heroDetail = "Every detail matters"
  override val philTitle =
    "For weddings with character, elegance, and a deep appreciation for unique moments."
  override val philPara1 =
    "At Tima Cookies, we believe that luxury lies in the details that cannot be mass-produced, blending edible design with modern wedding aesthetics to create miniature masterpieces that elegantly complement your special day."
  override val philPara2 =
    "When you choose Tima Cookies, you are not just choosing decoration, you are choosing dedication and an artistic creation crafted exclusively for you."
  override val selectionTitle = "Selection of finest creations"
  override val viewAllCreations = "VIEW ALL CREATIONS"
  override val creationPersonalizedFavor = "Personalised Favor"
  override val creationModernWeddingDesc = "Elegance in every bite"
  override val creationArtisticFloral = "Artistic Floral"
  override val creationArtisticFloralDesc = "Hand-painted edible art"
  override val creationLaceMonogram = "Lace Monogram"
  override val creationLuxuryGoldDesc = "Sophistication refined"
  override val creationsHeroTitle = "Edible Design & Modern Aesthetics"
  override val modernWeddingSubtitle = "A MINIATURE MASTERPIECE"
  override val artisticFloralSubtitle = "HAND-PAINTED ARTISTRY"
  override val luxuryGoldSubtitle = "GILDED PERFECTION"
  override val modernWeddingComposition = listOf(
    "Vanilla butter shortbread",
    "White royal icing",
    "Hand-crafted wafer paper florals",
    "Edible silver luster dust",
    "Sugar pearl accents",
  )
  override val modernWeddingProcess = listOf(
    "Each cookie is individually hand-cut from our premium butter shortbread dough.",
    "A smooth white royal icing base coat is applied and allowed to cure.",
    "Intricate patterns are piped by hand using a fine-tip nozzle.",
    "Wafer paper florals are individually hand-crafted and delicately placed.",
    "A final dusting of edible silver luster creates a soft, luminous finish.",
  )
  override val artisticFloralComposition = listOf(
    "Vanilla butter shortbread",
    "White royal icing base",
    "Edible watercolor pigments",
    "24k edible gold leaf",
    "Food-safe metallic paint",
  )
  override val artisticFloralProcess = listOf(
    "A pristine white royal icing base is flooded and dried to a smooth finish.",
    "Botanical motifs are sketched and hand-painted using edible watercolor pigments.",
    "Fine details are added layer by layer with a delicate paintbrush.",
    "Genuine 24k edible gold leaf is applied and burnished by hand.",
    "Each cookie is sealed to preserve the artistry for your special day.",
  )
  override val luxuryGoldComposition = listOf(
    "Vanilla butter shortbread",
    "Ivory royal icing",
    "24k edible gold leaf",
    "Metallic luster dust",
    "Edible pearl paint",
  )
  override val luxuryGoldProcess = listOf(
    "Multiple ivory royal icing layers are applied to build depth and smoothness.",
    "24k edible gold leaf is meticulously positioned sheet by sheet.",
    "Metallic luster dust is hand-applied with a fine brush for dimension.",
    "Edible pearl paint is brushed on to achieve a mirror-like, high-gloss finish.",
    "Each cookie is individually inspected before presentation.",
  )
  override val composition = "THE COMPOSITION"
  override val process = "THE CREATION PROCESS"
  override val backToTop = "BACK TO TOP"
  override val privacyPolicy = "PRIVACY POLICY"
  override val socialTitle = "SOCIAL"
  override val contactTitle = "CONTACT"
}

object DeStrings : AppStrings {
  override val navHome = "Startseite"
  override val navCreations = "Kreationen"
  override val heroTitle = "Kekse, die deine Geschichte erzählen"
  override val heroDetail = "Jedes Detail zählt"
  override val philTitle =
    "Für Hochzeiten mit Charakter, Eleganz und einer tiefen Wertschätzung für einzigartige Momente."
  override val philPara1 =
    "Bei Tima Cookies glauben wir, dass Luxus in den Details liegt, die nicht in Massenproduktion hergestellt werden können. Wir verbinden essbares Design mit moderner Hochzeitsästhetik, um Miniatur-Meisterwerke zu schaffen, die Ihren besonderen Tag elegant ergänzen."
  override val philPara2 =
    "Wenn Sie sich für Tima Cookies entscheiden, wählen Sie nicht nur Dekoration, sondern Hingabe und eine exklusiv für Sie gefertigte künstlerische Kreation."
  override val selectionTitle = "Auswahl feinster Kreationen"
  override val viewAllCreations = "ALLE KREATIONEN ANSEHEN"
  override val creationPersonalizedFavor = "Essbare Tishkarte"
  override val creationModernWeddingDesc = "Eleganz in jedem Bissen"
  override val creationArtisticFloral = "Künstlerische Floral"
  override val creationArtisticFloralDesc = "Handbemalte essbare Kunst"
  override val creationLaceMonogram = "Spitzenmonogramm"
  override val creationLuxuryGoldDesc = "Raffinierte Kultiviertheit"
  override val creationsHeroTitle = "Essbares Design & Moderne Ästhetik"
  override val modernWeddingSubtitle = "EIN MINIATUR-MEISTERWERK"
  override val artisticFloralSubtitle = "HANDBEMALTE KUNSTFERTIGKEIT"
  override val luxuryGoldSubtitle = "VERGOLDETE VOLLENDUNG"
  override val modernWeddingComposition = listOf(
    "Vanille-Buttermürbeteig",
    "Weiße Royal Icing",
    "Handgefertigte Waferpapier-Blüten",
    "Essbares Silberglanzpulver",
    "Zuckerperlenverzierung",
  )
  override val modernWeddingProcess = listOf(
    "Jedes Cookie wird einzeln von Hand aus unserem Premium-Buttermürbeteig ausgestochen.",
    "Eine glatte weiße Royal-Icing-Grundschicht wird aufgetragen und aushärten gelassen.",
    "Feine Muster werden von Hand mit einer Feinspitzdüse gespritzt.",
    "Waferpapierblüten werden einzeln handgefertigt und sorgfältig platziert.",
    "Ein abschließendes Essbares-Silberglanzpulver verleiht einen sanften, leuchtenden Glanz.",
  )
  override val artisticFloralComposition = listOf(
    "Vanille-Buttermürbeteig",
    "Weiße Royal-Icing-Basis",
    "Essbare Aquarellfarben",
    "24-Karat essbares Blattgold",
    "Lebensmittelechte metallische Farbe",
  )
  override val artisticFloralProcess = listOf(
    "Eine makellose weiße Royal-Icing-Basis wird gegossen und zu einer glatten Oberfläche getrocknet.",
    "Botanische Motive werden skizziert und mit essbaren Aquarellfarben von Hand gemalt.",
    "Feine Details werden Schicht für Schicht mit einem zarten Pinsel hinzugefügt.",
    "Echtes 24-Karat essbares Blattgold wird von Hand aufgebracht und poliert.",
    "Jedes Cookie wird versiegelt, um die Kunstfertigkeit für Ihren besonderen Tag zu bewahren.",
  )
  override val luxuryGoldComposition = listOf(
    "Vanille-Buttermürbeteig",
    "Elfenbeinfarbene Royal Icing",
    "24-Karat essbares Blattgold",
    "Metallisches Glanzpulver",
    "Essbarer Perlglanzlack",
  )
  override val luxuryGoldProcess = listOf(
    "Mehrere elfenbeinfarbene Royal-Icing-Schichten werden aufgetragen, um Tiefe und Glätte zu erzeugen.",
    "24-Karat essbares Blattgold wird Blatt für Blatt sorgfältig positioniert.",
    "Metallisches Glanzpulver wird mit einem feinen Pinsel von Hand aufgetragen.",
    "Essbarer Perlglanzlack wird aufgestrichen, um einen hochglänzenden, spiegelähnlichen Effekt zu erzielen.",
    "Jedes Cookie wird vor der Präsentation einzeln überprüft.",
  )
  override val composition = "DIE KOMPOSITION"
  override val process = "DER HERSTELLUNGSPROZESS"
  override val backToTop = "ZURÜCK NACH OBEN"
  override val privacyPolicy = "DATENSCHUTZERKLÄRUNG"
  override val socialTitle = "SOCIAL"
  override val contactTitle = "KONTAKT"
}

@Composable
fun localizedStrings(): AppStrings =
  when (currentLanguage()) {
    Language.EN -> EnStrings
    Language.DE -> DeStrings
  }

object Loc {
  fun path(
    lang: Language,
    subPath: String,
  ): String {
    val cleanPath = if (subPath.startsWith("/")) subPath else "/$subPath"
    // Normalize root path to empty string if lang is provided to avoid //
    val finalSubPath = if (cleanPath == "/") "" else cleanPath
    return "/${lang.name.lowercase()}$finalSubPath"
  }
}
